export const notify = {

  success: function (title, message, fixed) {
    $.notify({
      title: title === undefined || title === null || title.length <= 0 ? '' : title,
      message: message === undefined || message === null || message.length <= 0 ? '' : message
    },
      {
        type: 'liquid-success',
        delay: fixed === undefined || fixed === null || fixed === false ? 5000 : 0
      });
  },

  alert: function (title, message, fixed) {

    $.notify({
      title: title === undefined || title === null || title.length <= 0 ? '' : title,
      message: message === undefined || message === null || message.length <= 0 ? '' : message
    },
      {
        type: 'liquid-alert',
        delay: fixed === undefined || fixed === null || fixed === false ? 5000 : 0
      });
  },

  danger: function (title, message, fixed) {

    $.notify({
      title: title === undefined || title === null || title.length <= 0 ? '' : title,
      message: message === undefined || message === null || message.length <= 0 ? '' : message
    }, {
      type: 'liquid-danger',
      delay: fixed === undefined || fixed === null || fixed === false ? 5000 : 0
    });
  },

  closeAll: function () {

    $.notifyClose();
  }

};
